module.exports = __webpack_public_path__ + "img/Bitrix24.60356238.svg";